var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10355 0.646446C3.90829 0.451184 3.59171 0.451184 3.39645 0.646446L0.214465 3.82843C0.0192033 4.02369 0.0192033 4.34027 0.214465 4.53553C0.409728 4.7308 0.72631 4.7308 0.921572 4.53553L3.75 1.70711L6.57843 4.53553C6.77369 4.7308 7.09027 4.7308 7.28553 4.53553C7.4808 4.34027 7.4808 4.02369 7.28553 3.82843L4.10355 0.646446ZM4.25 14L4.25 1L3.25 1L3.25 14L4.25 14Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sort_arrow.5912d57bb1d3f178df4db5609624996b.svg";
export { ForwardRef as ReactComponent };